module.exports = __webpack_public_path__ + "static/media/kg.6374f7e4.svg";